import { NgModule } from '@angular/core';
import { AccredibleBrowserStorageService } from './browser-storage.service';

@NgModule({
  providers: [AccredibleBrowserStorageService],
})
export class AccredibleBrowserStorageServiceModule {}
